<template>
    <div class="finance-container finance-wrap">
        <h2>财务总览</h2>

        <!-- 财务数据概览 -->
        <div class="finance-overview">
            <div class="overview-item">
                <span class="label">账户总览：</span>
                <span class="value">{{ accountTotalData.total }}元</span>
            </div>
            <div class="overview-item">
                <span class="label">收支总金额：</span>
                <span class="value">{{ accountTotalData.receivable }}元</span>
            </div>
        </div>

        <!-- 账户搜索 -->
        <div class="account-search">
            <el-input v-model="query.name" placeholder="请输入账户名称" clearable
                style="width: 200px; margin-right: 10px;"></el-input>
            <div class="box-input-btn">
                <el-button class="default" @click="initQuery">查询</el-button>
            </div>
            <div class="box-input-btn" style="margin-left: auto;">
            <el-button class="box-input-btn-cz" @click="openAddAccountDialog('添加账户')">添加账户</el-button>
          </div>
        </div>

        <!-- 账户列表 -->
        <el-table :data="accountList"
            :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
            style="width: 100%" v-loading="loading" :height="'470px'" :cell-style="{ 'text-align': 'center' }">
            <el-table-column prop="accountName" label="账户名称">
            </el-table-column>
            <el-table-column prop="balance" label="余额">
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间">
            </el-table-column>
            <el-table-column prop="fee" label="费率">
                <template slot-scope="scope">
                    {{ scope.row.fee }}%
                </template>
            </el-table-column>
            <el-table-column prop="isAudit" label="是否审批">
                <template slot-scope="scope">
                    <span
                        :style="{ color: scope.row.isAudit === true || scope.row.isAudit === 1 || scope.row.isAudit === '1' || scope.row.isAudit === 'true' ? '#67C23A' : '#F56C6C' }">
                        {{ scope.row.isAudit === true || scope.row.isAudit === 1 || scope.row.isAudit === '1' ||
                            scope.row.isAudit === 'true' ? '是' : '否' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="marks" label="备注">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small">支出</el-button>
                    <el-button type="text" size="small">查看明细</el-button> -->
                    <el-button type="text" size="small" @click="openAddAccountDialog('编辑账户', scope.row)">编辑</el-button>
                    <el-button type="text" size="small" style="color: #F56C6C;"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="table-pagination">
            <el-pagination @current-change="currentChange" :current-page="query.page" :page-size="query.pageSize"
                layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 提示信息 -->
        <!-- <div class="tips">
            <span style="color: #F56C6C;">删除只能删除无流水账户</span>
        </div>
        <div class="tips">
            <span>双击编辑文本</span>
        </div> -->

        <!-- 添加账户对话框 -->
        <el-dialog :title="title" :visible.sync="addAccountDialogVisible" width="500px">
            <el-form ref="addAccountFormRef" :model="addAccountForm" :rules="addAccountRules" label-width="100px">
                <el-form-item label="账户名称" prop="accountName">
                    <el-input v-model="addAccountForm.accountName" placeholder="请输入账户名称"></el-input>
                </el-form-item>
                <el-form-item label="账户手续费" prop="fee">
                    <el-input v-model="addAccountForm.fee" placeholder="请输入账户手续费" @input="handleFeeInput">
                        <i slot="suffix">%</i>
                    </el-input>
                </el-form-item>
                <el-form-item label="初始化金额" prop="balance" v-if="title == '添加账户'">
                    <el-input v-model="addAccountForm.balance" placeholder="初始化金额"
                        @input="handleBalanceInput"></el-input>
                </el-form-item>
                <el-form-item label="人工审批" prop="isAudit">
                    <el-radio-group v-model="addAccountForm.isAudit">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="addAccountForm.marks" type="textarea" placeholder="请输入备注" :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addAccountDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAddAccount">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getQueryaccount, createdAddaccount, updateAccount, getaccounttotal, delaccount } from '@/api/finance';
export default {
    data() {
        return {
            addAccountDialogVisible: false,
            query: {
                name: '',
                page: 1,
                pageSize: 10,
            },
            addAccountForm: {
                isAudit: true,
                accountName: "",
                fee: 0,
                balance: 0,
                marks: ""

            },
            addAccountRules: {
                accountName: [
                    { required: true, message: '请输入账户名称', trigger: 'blur' }
                ],
                fee: [
                    { required: true, message: '请输入账户手续费', trigger: 'blur' },
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入数字', trigger: 'blur' }
                ],
                balance: [
                    { required: true, message: '请输入初始化金额', trigger: 'blur' },
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入数字', trigger: 'blur' }
                ],
                isAudit: [
                    { required: true, message: '请选择人工审批', trigger: 'blur' }
                ]
            },
            accountList: [],
            accountListAll: [],
            title: '添加账户',
            total: 0,
            accountTotalData: {
                total: 0,
                receivable: 0
            }
        }
    },
    methods: {
        openAddAccountDialog(title, item = {}) {
            this.addAccountDialogVisible = true;
            this.title = title;
            if (this.title == '添加账户') {
                this.addAccountForm = {
                    isAudit: true,
                    accountName: "",
                    fee: 0,
                    balance: 0,
                    marks: ""
                }
            } else {
                this.addAccountForm = {
                    isAudit: item.isAudit,
                    id: item.id,
                    accountName: item.accountName,
                    fee: item.fee,
                    balance: item.balance,
                    marks: item.marks
                }
            }
        },
        saveAddAccount() {
            // 表单校验
            this.$refs.addAccountFormRef.validate((valid) => {
                if (valid) {
                    // 处理初始化金额，确保有两位小数
                    if (this.addAccountForm.balance) {
                        let balance = this.addAccountForm.balance.toString();
                        if (!balance.includes('.')) {
                            balance += '.00';
                        } else {
                            const parts = balance.split('.');
                            if (parts[1].length < 2) {
                                balance = parts[0] + '.' + parts[1].padEnd(2, '0');
                            }
                        }
                        this.addAccountForm.balance = balance;
                    }
                    // 保存逻辑
                    console.log('保存数据:', this.addAccountForm);
                    if (this.title == '添加账户') {
                        this.createAccount();
                    }
                    else {
                        this.editAccount();
                    }
                } else {
                    return false;
                }
            });
        },
        editAccount() {
            updateAccount(this.addAccountForm).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                    this.query.page = 1;
                    this.getQueryaccountList();
                    // 关闭对话框
                    this.addAccountDialogVisible = false;
                    // 重置表单
                    this.addAccountForm = {
                        accountName: '',
                        fee: 0,
                        balance: '',
                        marks: 0
                    };
                }
            })
        },
        createAccount() {
            createdAddaccount(this.addAccountForm).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.query.page = 1;
                    this.getQueryaccountList();
                    // 关闭对话框
                    this.addAccountDialogVisible = false;
                    // 重置表单
                    this.addAccountForm = {
                        name: '',
                        balance: '',
                        remark: ''
                    };
                }
            })
        },
        getQueryaccountList() {
            getQueryaccount({
                "Name": this.query.name,
                "Page.Index": this.query.page,
                "Page.Size": this.query.pageSize,
            }).then(res => {
                this.accountList = res.data.rows;
                this.total = res.data.total;
            })
        },
        currentChange(value) {
            this.query.page = value;
            this.getQueryaccountList();

        },
        handleFeeInput() {
            // 只允许输入数字
            this.addAccountForm.fee = this.addAccountForm.fee.toString().replace(/[^0-9.]/g, '');
        },
        handleBalanceInput() {
            // 只允许输入数字
            let value = this.addAccountForm.balance.toString().replace(/[^0-9.]/g, '');
            // 处理小数
            if (value.includes('.')) {
                // 如果有小数点，确保只有两位小数
                const parts = value.split('.');
                if (parts.length > 2) {
                    value = parts[0] + '.' + parts[1].substring(0, 2);
                } else if (parts[1] && parts[1].length > 2) {
                    value = parts[0] + '.' + parts[1].substring(0, 2);
                }
            }
            this.addAccountForm.balance = value;
        },
        initQuery() {
            this.query.page = 1;
            this.getQueryaccountList();
        },
        handleDelete(row) {
            this.$confirm('确认要删除该账户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delaccount({ id: row.id }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getQueryaccountList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg || '删除失败'
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    },
    created() {
        this.getQueryaccountList();
        getQueryaccount().then(res => {
            this.accountListAll = res.data.rows;
        })
        getaccounttotal().then(res => {
            this.accountTotalData.total = res.data.total;
            this.accountTotalData.receivable = res.data.receivable;
        })
    }
}
</script>
<style scoped lang="scss">
.finance-container {
    padding: 20px;

    h2 {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .finance-overview {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e4e7ed;

        .overview-item {
            margin-right: 30px;

            .label {
                font-size: 14px;
                color: #606266;
            }

            .value {
                font-size: 14px;
                color: #303133;
                font-weight: 500;
            }
        }
    }

    .account-search {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e4e7ed;

        .label {
            font-size: 14px;
            color: #606266;
            margin-right: 10px;
        }
    }

    .tips {
        margin-top: 10px;
        font-size: 12px;
        color: #909399;
    }
}

.table-pagination {
    margin-top: 15px;
    text-align: right;
}

.finance-wrap {
    // width: 953px;
    width: calc(100% - 30px);

    ::v-deep .el-select {
        margin-right: 5px;
        width: 125px;
    }

    ::v-deep .el-input__inner {
        background: #F2F4F7;
        border: none;
    }

    ::v-deep .el-table__row {
        .cell {
            font-size: 12px;
        }
    }

    ::v-deep .el-date-editor {
        margin-right: 5px;
        width: 240px;

        .el-range-input {
            background: transparent;
        }

        .el-range__close-icon {
            width: 10px;
        }
    }

    .box-table {
        height: calc(100% - 210px) !important;

        ::v-deep .el-table__body-wrapper {
            height: 100% !important;
            height: auto !important;
        }
    }

    .box-top {
        width: 593px;
        height: 81px;
        background: #FFFFFF;
        box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 5px 10px;

        .top-item {
            width: 30%;

            p {
                color: #666;
                font-size: 12px;
            }

            .balance {
                color: #333333;
                font-size: 20px;
                font-weight: bold;
            }

            .iconfont {
                vertical-align: middle;
                margin-right: 5px;
            }
        }
    }

}

.box-input-btn {
    text-align: right;

    .box-input-btn-cz {
        background: #EAF3FF;
        color: #3888E9;
        border: none;
    }

    .box-input-btn-add {
        background: #D8F5E4;
        color: #54D8A5;
        border: none;
    }
}
</style>
